import { NextPage } from 'next'
import MotorVehicleScreen from '../screens/MotorVehicle'
import AppMotorVehicleScreen from '../screens/App-MotorVehicle'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const MotorVehicle: NextPage = () => {
  const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<MotorVehicleScreen />) : (<AppMotorVehicleScreen />)}
        </>
    )
}
